import React from 'react';
import Icon from '@pushpay/icon';

const WarningIcon = props => {
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.15 4.25l7.595 14.2c.167.33.25.743.25 1.073C22.08 20.927 20.994 22 19.66 22H4.469c-.417 0-.751-.083-1.168-.248-1.169-.578-1.67-2.064-1.002-3.22L9.894 4.25c.25-.413.584-.743 1.001-.99 1.169-.579 2.671-.166 3.255.99zm-2.086.33c-.167 0-.25 0-.334.083a.648.648 0 00-.334.33L3.801 19.276c-.167.412-.083.908.334 1.073.084.082.25.082.334.082h15.19c.417 0 .834-.33.834-.825 0-.165 0-.248-.083-.33L12.815 4.993c-.167-.248-.5-.413-.751-.413zm0 11.889c.667 0 1.252.495 1.252 1.238 0 .54-.437 1.079-1.038 1.215l-.13.023c-.668 0-1.253-.578-1.253-1.238 0-.62.44-1.166 1.046-1.232l.123-.006zm0-7.678c.5 0 .834.33.834.825v4.954c0 .495-.333.825-.834.825-.5 0-.835-.33-.835-.825V9.616c0-.495.334-.825.835-.825z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

export default WarningIcon;